import { render, staticRenderFns } from "./StipendialSelector.vue?vue&type=template&id=757c859a&"
import script from "./StipendialSelector.vue?vue&type=script&lang=js&"
export * from "./StipendialSelector.vue?vue&type=script&lang=js&"
import style0 from "./StipendialSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports